import _                from 'lodash'
import pluralize        from 'pluralize'
import EntityCollection from './entity_collection'
import PaginationInfo   from './pagination_info'

export default class BackendResponse
  constructor: (@response, @model, @associations, @includedModels, @pageNumber, @pageSize) ->
    @results = @response.results or @response

  entity: ->
    entity = @_entityFor(@model)

    if entity and @includedModels.length
      primaryCollection = EntityCollection.singletonFor(entity, @associations)

      @_jointCollectionFor(primaryCollection).first()
    else
      entity

  collection: ->
    primaryCollection = @_collectionFor(@model)

    if @includedModels.length
      collection = @_jointCollectionFor(primaryCollection)
    else
      collection = primaryCollection

    collection.pagination = new PaginationInfo(@pageNumber, @pageSize, @response.count)

    collection

  _jointCollectionFor: (primaryCollection) ->
    joinReducer     = (running, current) -> running.join(current)
    jointCollection = _.reduce(@_assocCollections(), joinReducer, primaryCollection)

  _assocCollections: ->
    @includedModels.map (model) => @_collectionFor(model, false)

  _entityFor: (model) ->
    model.deserialize(@response[_.snakeCase(model.name)])

  _collectionFor: (model, primary = true) ->
    rows       = @_rowsFor(model, primary)
    entities   = rows.map (row) -> model.deserialize(row)
    collection = EntityCollection.for(entities, model, @associations)

  _rowsFor: (model, primary = true) ->
    key      = _.snakeCase(pluralize(model.name))
    assocKey = '+' + key

    if primary
      rows = @results[key]
    else
      rows = _.concat(@results[key] or [], @results[assocKey] or [])
